export function getBaseAssetCode(pairName?: string) {
  return pairName?.split('/')?.[0] ?? 'unknown';
}

export function getQuoteAssetCode(pairName?: string) {
  return pairName?.split('/')?.[1] ?? 'unknown';
}
